import { render, staticRenderFns } from "./volunteerRoles.vue?vue&type=template&id=6e173280&scoped=true"
import script from "./volunteerRoles.vue?vue&type=script&lang=js"
export * from "./volunteerRoles.vue?vue&type=script&lang=js"
import style0 from "./volunteerRoles.vue?vue&type=style&index=0&id=6e173280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e173280",
  null
  
)

export default component.exports